module.exports = require("@bee-hole/cache");